import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { Modal, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { FaRegCircleCheck, FaWhatsapp } from 'react-icons/fa6'; // FaRupeeSign removed
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { SlArrowLeft } from 'react-icons/sl';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import '../../../jsx/Dashborad/dashboard.css';
import CivilButton from '../../ReusableComponent/CIVIL/CivilButton/CivilButton';
import PaymentModal from '../PaymentService/PaymentModal';

function LanguageSubjectsHome() {
    const navigate = useNavigate();
    const location = useLocation();
    const alert = useAlert();

    const [open, setOpen] = useState(false);
    const [openPaymentProccessingModal, setPaymentProccessingModal] = useState(false);
    const email = localStorage.getItem("authtoken")
    const [loadingTests, setLoadingTests] = useState(false);
    // const [testSeriesData, setTestSeriesData] = useState(null);
    const [subjcts, setSubjects] = useState([]);
    const [testPlans, setTestPlans] = useState([])
    const [selectedSubject, setSelectedSubject] = useState({ Sn: 0, SubjectType: 'Please select subject' });
    const [selectedTest, setSelectedTest] = useState({ Sn: 1, TestCount: 5, Price: 500, Discount: 0 });
    const [tests, setTests] = useState([]);
    const [subjectSpecificData, setSubjectSpecificData] = useState({});
    const [openPaymentSuccessModal, setPaymentSuccessModal] = useState(false);
    const [transactionId, setTransactionId] = useState('');
    const enrolled = transactionId.length > 0 ? true : false;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response1 = await axios.get(BASE_URL + `/cuet/user/subjects/Section-IA`);
                setSubjects(response1.data.data);
                setSelectedSubject(response1.data.data[0]);
                const response3 = await axios.get(BASE_URL + `/cuet/user/subject-specific-data/Section-IA`);
                setSubjectSpecificData(response3?.data?.data[0]);
            } catch (error) {
                console.log(error);
            }

        }
        fetchInitialData()
    }, []);

    useEffect(() => {
        const loadData = async () => {
            try {
                const response2 = await axios.get(BASE_URL + `/cuet/user/testplans/Section-IA/${selectedSubject.Sn}`);
                const planData = response2?.data?.data;
                setTestPlans(planData || []);
                if (planData && planData.length > 0) {
                    setSelectedTest(planData[0]);
                } else {
                    setSelectedTest(null);
                }
            } catch (error) {
                console.log(error);
                alert.show(error?.response?.data?.message || "Error loading test plans");
            }

        }
        if (selectedSubject.Sn) {
            loadData();
        }
    }, [selectedSubject]);

    useEffect(() => {
        if (selectedTest?.TestCount) {
            setTests(new Array(selectedTest.TestCount).fill(1));
        } else {
            setTests([]);
        }
    }, [selectedTest?.Sn])

    const testSeriesPrice = selectedTest?.Price?.toLocaleString('en-IN') || "0";
    const priceAfterDiscount = selectedTest ? (selectedTest.Price - (selectedTest.Price * (selectedTest.Discount / 100))) : 0;
    const payableAmount = Math.ceil(priceAfterDiscount);

    const handleEnroll = () => {
        if (!selectedSubject?.Sn || !selectedTest?.Sn) {
            alert.show("Please Choose your Subject and Select Number of Tests");
            return;
        }
        if (email) {
            setOpen(true);
        } else {
            navigate('/login');
        }
    }

    return (
        <>
            <Helmet>
                {/* <title>{"CUET|Seciton-IA"}</title> */}
                <title>{"CUET|Language Subjects"}</title>
                {/* <meta name="description" content={`${testSeriesData.MetaDescription}`}></meta> */}
            </Helmet>
            {/* Civil Test Page Start */}
            <div className='Dashboard-background'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-3 col-md-12 col-sm-12 dashboardmain-left p-3'>
                            <div className='dashboardleft-background'>
                                <div className='dash1'>
                                    <img src={subjectSpecificData?.Thumbnail} alt={"..."} className='dash2-img' />
                                </div>
                                <div className='dash2'>
                                    <div className="d-grid gap-2">
                                        <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, selecteSection: 'Language Subjects', moduleName: 'cuet' }} className="btn d-flex align-items-center justify-content-center btn-orange fw-bold py-3" type="button" style={{ letterSpacing: '0.5px', fontSize: '1.05rem' }}>Dashboard</Link>
                                        <div className="border border-2 rounded border-gray">
                                            <label htmlFor="select_test" className='btn_custom_class btn d-flex align-items-center justify-content-center fw-bold text-white text-uppercase' style={{ cursor: 'default' }}>Choose your Subject</label>
                                            <Select
                                                id='select_test'
                                                value={{ value: selectedSubject, label: selectedSubject?.SubjectType }}
                                                onChange={(selectedOption) => setSelectedSubject(selectedOption.value)}
                                                options={subjcts?.map((item) => ({ value: item, label: item?.SubjectType }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        backgroundColor: 'white',
                                                        borderColor: '#17a2b8',
                                                        cursor: 'pointer'
                                                    }),
                                                    option: (provided) => ({
                                                        ...provided,
                                                        cursor: 'pointer',
                                                        textAlign: 'center'
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        textAlign: 'center'
                                                    })
                                                }}
                                            />
                                        </div>
                                        <div className="border border-2 rounded border-gray">
                                            <label htmlFor="select_test_count" className='btn_custom_class btn d-flex align-items-center justify-content-center fw-bold text-white text-uppercase' style={{ cursor: 'default' }} >Select Number of Tests</label>
                                            <Select
                                                id='select_test_count'
                                                value={selectedTest ? { value: selectedTest, label: (selectedTest.TestCount || 0) + " Tests" } : null}
                                                onChange={(selectedOption) => setSelectedTest(selectedOption.value)}
                                                options={testPlans?.map((item) => ({ value: item, label: (item.TestCount || 0) + " Tests" }))}
                                                placeholder="Select Plans"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        backgroundColor: 'white',
                                                        borderColor: '#17a2b8',
                                                        cursor: 'pointer'
                                                    }),
                                                    option: (provided) => ({
                                                        ...provided,
                                                        cursor: 'pointer',
                                                        textAlign: 'center'
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        textAlign: 'center'
                                                    })
                                                }}
                                            />
                                        </div>




                                        <button
                                            onClick={handleEnroll}
                                            className="btn btn-orange py-2 px-3 d-flex flex-column align-items-center justify-content-center"
                                            type="button"
                                        >
                                            {selectedTest?.Sn && selectedSubject?.Sn ? (
                                                <>
                                                    <div className='d-flex align-items-center justify-content-center flex-wrap mb-1' style={{ gap: "10px", opacity: 0.9 }}>
                                                        <span className='text-decoration-line-through text-uppercase' style={{ fontSize: '1rem' }}>
                                                            FEE ₹{testSeriesPrice}
                                                        </span>
                                                        <span className='fw-bold text-uppercase' style={{ fontSize: '1rem', background: 'rgba(255,255,255,0.2)', padding: '2px 8px', borderRadius: '4px' }}>
                                                            DISCOUNT {selectedTest?.Discount || 0}%
                                                        </span>
                                                    </div>
                                                    <div className='fw-bold text-uppercase' style={{ fontSize: '1.1rem', letterSpacing: '1px' }}>
                                                        ₹{payableAmount?.toLocaleString('en-IN')} - {payableAmount < 1 ? 'ENROLL FOR FREE' : 'ENROLL NOW'}
                                                    </div>
                                                </>
                                            ) : (
                                                <div className='fw-bold text-uppercase' style={{ fontSize: '1.2rem', letterSpacing: '1px', padding: '10px 0' }}>
                                                    ENROLL NOW
                                                </div>
                                            )}
                                        </button>
    

                                        <Link to="https://api.whatsapp.com/send?phone=919818333201" target='_blank' className="btn d-flex align-items-center justify-content-center btn-whatsapp fw-bold py-3" type="button" style={{ letterSpacing: '0.5px', fontSize: '1.05rem' }}><FaWhatsapp className='me-1 fs-4' /> WHATSAPP 9818333201</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-9 col-md-12 col-sm-12'>
                            <div className="d-flex justify-content-between align-items-center p-2 py-1 mb-3 bg-light border rounded shadow-sm">
                                <button
                                    className="btn btn-sm"
                                    style={{
                                        backgroundColor: '#17a2b8',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        padding: '4px 12px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => navigate(-1)}
                                >
                                    <SlArrowLeft /> Back
                                </button>
                                <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>Language Subjects</h2>
                                <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, selecteSection: 'Language Subjects', moduleName: 'cuet' }} style={{ textDecoration: 'none', color: '#17a2b8', fontWeight: 'bold' }}>Dashboard</Link>
                            </div>
                            <CivilButton componentName="Language Subjects" ExamType='Section-IA' CUET_Tests={tests} loadingCUETTests={loadingTests} CUET_SubjectType={selectedSubject.SubjectType} overView={subjectSpecificData?.Description} enrolled={enrolled} onTakeTest={handleEnroll} />
                            {/* <CivilButton setOpenPaymentModal={setOpen} testSeriesData={testSeriesData} componentName={componentName} authtoken={storedAuthToken} /> */}
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={open} centered className="animate__animated animate__fadeIn mobileyoutube">
                <PaymentModal setOpen={setOpen} Amount={payableAmount} ExamType="Section-IA" TestCount={selectedTest?.TestCount || 0} SubjectType={selectedSubject?.SubjectType} SubjectID={selectedSubject?.Sn} setPaymentProccessingModal={setPaymentProccessingModal} setPaymentSuccessModal={setPaymentSuccessModal} setTransactionId={setTransactionId} />
            </Modal>
            <Modal show={openPaymentProccessingModal} top backdrop="static" dialogClassName="custom-modal-width">
                <div className="modal-content" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className="modal-body" style={{ padding: "2rem" }}>
                        <div className="mb-3 d-block text-center">
                            <Spinner
                                animation="border"
                                className="mt-5 mb-3"
                                size="xl"
                                style={{ width: "200px", height: "200px", color: "#ff2f00" }}

                            />
                            <h5
                                className="modal-title mb-5"
                                id="exampleModalLabel"
                                style={{ color: "#17a2b8", fontFamily: "Arial, sans-serif" }}
                            >
                                Saving Order Details. This may take a moment...
                            </h5>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal show={openPaymentSuccessModal} top backdrop="static" dialogClassName="" size="lg" centered>
                <div className="" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className='p-5 py-3 d-flex justify-content-center align-items-center' >
                        <div className='text-black text-center'>
                            <FaRegCircleCheck className='text-orange' style={{ fontSize: "15vmax" }} />
                            <h1 className='py-2 fw-bold text-success'>Payment Successful</h1>
                            <h4 className='text-info'>Your order has been placed Successfully</h4>
                            <h6 > <span style={{ fontWeight: "700" }}>Program Name</span> :'Language Subjects' - {selectedSubject?.SubjectType}</h6>
                            <h6 ><span style={{ fontWeight: "700" }}>Payment ID</span> : {transactionId}</h6>

                            {/* <h6>Payment ID:</h6> */}
                            {/* <h6>{paymentdetail[0].TranscationID}</h6> */}
                            {/* <div className='p-3 d-flex justify-content-center'>
                                <button onClick={() => setPaymentSuccessModal(false)} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4' >
                                    done
                                </button>
                            </div> */}
                            <div className='p-3 d-flex justify-content-around flex-column w-75 mx-auto '>
                                <Link to={`/StudentDashboard`} state={{ prePath: location.pathname, selecteSection: 'Language Subjects', moduleName: 'cuet' }} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4' >
                                    Go to My Dashboard
                                </Link>
                                <Link onClick={() => setPaymentSuccessModal(false)} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4 my-2' >
                                    Close
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* Civil Test Page End */}
        </>
    )
}

export default LanguageSubjectsHome;